export default __webpack_public_path__ + "static/media/notice.6a8cfe32.svg";